// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectApprovalRequest
 */
export interface RejectApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectApprovalRequest
     */
    rejection_reason: string;
    /**
     * 
     * @type {string}
     * @memberof RejectApprovalRequest
     */
    status: string;
}

/**
 * Check if a given object implements the RejectApprovalRequest interface.
 */
export function instanceOfRejectApprovalRequest(value: object): value is RejectApprovalRequest {
    if (!('rejection_reason' in value) || value['rejection_reason'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RejectApprovalRequestFromJSON(json: any): RejectApprovalRequest {
    return RejectApprovalRequestFromJSONTyped(json, false);
}

export function RejectApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rejection_reason': json['rejection_reason'],
        'status': json['status'],
    };
}

export function RejectApprovalRequestToJSON(json: any): RejectApprovalRequest {
    return RejectApprovalRequestToJSONTyped(json, false);
}

export function RejectApprovalRequestToJSONTyped(value?: RejectApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rejection_reason': value['rejection_reason'],
        'status': value['status'],
    };
}
